
// import React, { useState } from "react";

// const ProductData = () => {

//   const [activeButton, setActiveButton] = useState("hourly");
   
//   return (
//     <>
//     <div className="w-full h-screen flex items-start justify-center mt-6">
//       <div className="w-[698px] h-[189px] flex flex-col items-center justify-center gap-12  p-6">
//         <h2 className="text-3xl font-semibold">Our Fleet in Belagavi</h2>
//         <p className="text-xs text-gray-600 text-center">
//           *Prices exclude taxes and fuel. Images are for representation purposes only, and the actual color may vary
//         </p>
//         <div className="flex space-x-4 bg-[#FFF2C6] p-1 rounded-md">
//       <button
//         onClick={() => setActiveButton("hourly")}
//         className={`py-1 px-6 rounded-full  ${
//           activeButton === "hourly" ? "bg-[#C06C3D] text-white" : " text-gray-600" 
//         }`}
//       >
//         Hourly
//       </button>

//       <button
//         onClick={() => setActiveButton("subscription")}
//         className={`py-1 px-6 rounded-full ${
//           activeButton === "subscription" ? "bg-[#C06C3D] text-white" : " text-gray-600"
//         }`}
//       > 
//         Subscription
//       </button>
//     </div>
//       </div>  
//     </div>
//     </>
//   );
// };

// export default ProductData;



import React, { useState } from "react";
import Products from "./Products";
import Bikes from "./Bikes";

 const ProductData = () => {

  const [activeButton, setActiveButton] = useState("hourly");
  return (
    <>
      <div className="w-full  flex items-start justify-center mt-6">
        <div className="w-full h-auto flex flex-col items-center justify-center gap-12">
          <h2 className="text-3xl font-semibold text-[#FF9630]">Our Fleet in Belagavi</h2>
          <p className="text-xs text-gray-600 text-center">
            *Prices exclude taxes and fuel. Images are for representation purposes only, and the actual color may vary
          </p>
          <div className="flex space-x-4 bg-[#FFF2C6] p-1 rounded-md">
            <button
              onClick={() => setActiveButton("hourly")}
              className={`py-1 px-6 rounded-full ${
                activeButton === "hourly" ? "bg-[#FF9630] text-white" : "text-gray-600"
              }`}

            >
              Hourly
            </button>

            <button
              onClick={() => setActiveButton("subscription")}
              className={`py-1 px-6 rounded-full ${
                activeButton === "subscription" ? "bg-[#FF9630] text-white" : "text-gray-600"
              }`}
            >
              Subscription
            </button>
          </div>
        </div>
      </div>

      {/* Conditional Rendering */}
      <div className="flex justify-center mt-6">
        {activeButton === "hourly" ? <Products /> : <Bikes/>}
      </div>
    </>
  );
};

export default ProductData;
